exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-page-search-wrapper[data-v-f7697bf6] { margin-bottom: 15px;\n}\n.route-summary[data-v-f7697bf6] {\n  color: #888;\n  font-size: 12px;\n}\n", ""]);

// exports
